import { createApp } from 'vue'
import App from './App.vue'
import { store } from './store'
import routes from './router'
// import axios from './utils/request'
import loading from './utils/loading.js' // 引入loading
import Bus from './utils/bus.js'
import guid from "@/utils/guid";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
/// mitt 总线程引入
// import ElementPlus from 'element-plus';


// eslint-disable-next-line no-unused-vars
const getUser = async() => {
  try {
    const res = await store.dispatch('getUserInfo')
    store.commit('setPath', res.name)
    console.log(res)
  } catch (e) {
    location.replace(`http://47.95.5.207/user/#/login?from=${location.href}`)
  }
}

const init = async () => {
  // await getUser() // 查询登录状态
  store.commit('setUid', guid())
  console.log(store)
  const app = createApp(App)
  app.use(store)
  app.use(routes)
  app.use(loading)
  app.use(ElementPlus)
  app.config.globalProperties.$bus = Bus
  app.mount('#app')
}
init()

